(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8921],{

/***/ 61692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AdmissionsDay_AdmissionsDayLanding; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/AdmissionsDay/AdmissionDayheadr.tsx
var AdmissionDayheadr = __webpack_require__(77093);
// EXTERNAL MODULE: ./styles/countryadmissionsday.module.scss
var countryadmissionsday_module = __webpack_require__(83157);
var countryadmissionsday_module_default = /*#__PURE__*/__webpack_require__.n(countryadmissionsday_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
;// CONCATENATED MODULE: ./components/AdmissionsDay/AboutQut.tsx







const AboutQut = ({ aboutdata  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (countryadmissionsday_module_default()).studentSpecialOffer,
            style: {
                backgroundColor: aboutdata?.sectionBgColor || "#FFDCD8"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xl: 5,
                            lg: 5,
                            md: 5,
                            sm: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (countryadmissionsday_module_default()).stuImg,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: aboutdata?.sectionImage || "/images/admissionsday/about-qut.svg",
                                    width: 207,
                                    height: 207,
                                    className: (countryadmissionsday_module_default()).cardImg,
                                    layout: "responsive",
                                    alt: "University-Representative.png"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xl: 7,
                            lg: 7,
                            md: 7,
                            sm: 12,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (countryadmissionsday_module_default()).headingabout,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: aboutdata.sectionTitle
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (countryadmissionsday_module_default()).OffersContent,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (countryadmissionsday_module_default()).OffersContent,
                                        children: aboutdata?.offers?.length > 0 && aboutdata.offers.map((offerabt, ind)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: offerabt
                                            }, ind);
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var AdmissionsDay_AboutQut = (AboutQut);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./hooks/useZipmeLink.tsx
var useZipmeLink = __webpack_require__(98196);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
;// CONCATENATED MODULE: ./components/AdmissionsDay/WhyChoose.tsx










const WhyChoose = ({ whyChoosedata , jotformId , externalLink  })=>{
    const { zipmeLink , generateLink  } = (0,useZipmeLink/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (countryadmissionsday_module_default()).studentSpecialOffer,
            style: {
                backgroundColor: "#EFEFFA"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: (countryadmissionsday_module_default()).centerAlign,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xl: 6,
                            lg: 6,
                            md: 6,
                            sm: 12,
                            className: (countryadmissionsday_module_default()).stuImgtext,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (countryadmissionsday_module_default()).heading,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: whyChoosedata.sectionTitle
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (countryadmissionsday_module_default()).OffersContent,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: (countryadmissionsday_module_default()).ulli,
                                        children: whyChoosedata?.offers?.length > 0 && whyChoosedata.offers.map((offerabt, ind)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: offerabt
                                            }, ind);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (countryadmissionsday_module_default()).anchor,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            onClick: ()=>{
                                                !jotformId && generateLink(externalLink);
                                            },
                                            className: `${(countryadmissionsday_module_default()).btnReg} ${jotformId ? ` ${(0,helpers/* isFrappeOrJotFormClass */.gd)(jotformId)}` : ""}`,
                                            children: "Register Now"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                            dangerouslySetInnerHTML: {
                                                __html: `window.lintrk('track', { conversion_id: 6870956 });`
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xl: 6,
                            lg: 6,
                            md: 6,
                            sm: 12,
                            className: (countryadmissionsday_module_default()).whystuImg,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: whyChoosedata?.sectionImage || "/images/admissionsday/whychoose-kc.svg",
                                    width: 207,
                                    height: 207,
                                    className: (countryadmissionsday_module_default()).cardImg,
                                    layout: "responsive",
                                    alt: "University-Representative.png"
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var AdmissionsDay_WhyChoose = (WhyChoose);

// EXTERNAL MODULE: ./components/AdmissionsDay/PopularCourses.tsx
var PopularCourses = __webpack_require__(6375);
// EXTERNAL MODULE: ./components/AdmissionsDay/WhyStudyinCountry.tsx
var WhyStudyinCountry = __webpack_require__(67962);
// EXTERNAL MODULE: ./components/AdmissionsDay/StudiesFAQ.tsx
var StudiesFAQ = __webpack_require__(26102);
// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./components/OverseasEdutionFair/eduFairStudTestimonials.tsx
var eduFairStudTestimonials = __webpack_require__(91071);
// EXTERNAL MODULE: ./components/OverseasEdutionFair/eduFairKcByNumber.tsx
var eduFairKcByNumber = __webpack_require__(17057);
// EXTERNAL MODULE: ./components/OverseasEdutionFair/eduFairWhyChoosekc.tsx
var eduFairWhyChoosekc = __webpack_require__(17477);
// EXTERNAL MODULE: ./components/OverseasEdutionFair/eduFairFooter.tsx
var eduFairFooter = __webpack_require__(74050);
// EXTERNAL MODULE: ./components/AdmissionsDay/BenefitsOfAdmissionsDay.tsx
var BenefitsOfAdmissionsDay = __webpack_require__(48664);
// EXTERNAL MODULE: ./components/AdmissionsDay/ParticipatingUniversities/ParticipatingUniversities.module.scss
var ParticipatingUniversities_module = __webpack_require__(6054);
var ParticipatingUniversities_module_default = /*#__PURE__*/__webpack_require__.n(ParticipatingUniversities_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/AdmissionsDay/ParticipatingUniversities/ParticipatingUniversities.tsx







const ParticipatingUniversities = ({ universitydata , univertitle , universitybackcolor  })=>{
    const router = (0,next_router.useRouter)();
    const { generateLink  } = (0,useZipmeLink/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ParticipatingUniversities_module_default()).universitiesSection,
            style: {
                backgroundColor: universitybackcolor || "#F2F8FF"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ParticipatingUniversities_module_default()).sectionContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ParticipatingUniversities_module_default()).sectionHeading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: univertitle
                        })
                    })
                }),
                router.pathname.includes("/company/") ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ParticipatingUniversities_module_default()).sectionContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ParticipatingUniversities_module_default()).universitiesList,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ParticipatingUniversities_module_default()).cardsGrid,
                            children: universitydata?.length > 0 && universitydata?.map((universitydetails, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ParticipatingUniversities_module_default()).cardWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ParticipatingUniversities_module_default()).universityCard,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (ParticipatingUniversities_module_default()).cardImageWrapper,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: universitydetails?.cardImage?.imageUrl || "/images/admissionsday/universitya.png",
                                                    width: 316,
                                                    height: 180,
                                                    className: (ParticipatingUniversities_module_default()).cardImage,
                                                    alt: "University-Representative.png"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (ParticipatingUniversities_module_default()).cardBody,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (ParticipatingUniversities_module_default()).universityName,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            children: universitydetails?.cardUniversityName?.label
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (ParticipatingUniversities_module_default()).universitySubtitle,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            children: universitydetails?.cardUniversityName?.value
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (ParticipatingUniversities_module_default()).detailsRow,
                                                        children: universitydetails?.cardDetails?.length > 0 && universitydetails?.cardDetails?.map((cardtext, detailIndex)=>{
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (ParticipatingUniversities_module_default()).detailLabel,
                                                                        children: cardtext?.label
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (ParticipatingUniversities_module_default()).detailValue,
                                                                        children: cardtext?.value
                                                                    })
                                                                ]
                                                            }, detailIndex);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (ParticipatingUniversities_module_default()).registerButtonWrapper,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                type: "button",
                                                                onClick: ()=>{
                                                                    if (!universitydetails?.jotformId) {
                                                                        generateLink(universitydetails?.externalLink ?? "");
                                                                    }
                                                                },
                                                                className: `${(ParticipatingUniversities_module_default()).registerButton} ${universitydetails?.jotformId ? `${(0,helpers/* isFrappeOrJotFormClass */.gd)(universitydetails?.jotformId)}` : ""}`,
                                                                children: router.pathname.includes("/company/") ? "Apply Now" : "Register Now"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: `window.lintrk('track', { conversion_id: 6870956 });`
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, index);
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ParticipatingUniversities_ParticipatingUniversities = (ParticipatingUniversities);

// EXTERNAL MODULE: ./components/OverseasEdutionFair/GrabChanceSection.tsx
var GrabChanceSection = __webpack_require__(54455);
// EXTERNAL MODULE: ./components/OverseasEdutionFair/AccomplishSection.tsx
var AccomplishSection = __webpack_require__(79782);
// EXTERNAL MODULE: ./components/AdmissionsDay/HowToAttendEvent.tsx
var HowToAttendEvent = __webpack_require__(63700);
// EXTERNAL MODULE: ./components/AdmissionsDay/DelegatesSection/DelegatesSection.module.scss
var DelegatesSection_module = __webpack_require__(13684);
var DelegatesSection_module_default = /*#__PURE__*/__webpack_require__.n(DelegatesSection_module);
;// CONCATENATED MODULE: ./components/AdmissionsDay/DelegatesSection/DelegatesSection.tsx




const DelegatesSection = ({ universitydata , univertitle , universitybackcolor  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (DelegatesSection_module_default()).delegatesSection,
            style: {
                backgroundColor: universitybackcolor || "#F2F8FF"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (DelegatesSection_module_default()).sectionContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (DelegatesSection_module_default()).sectionHeading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: univertitle
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (DelegatesSection_module_default()).sectionContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (DelegatesSection_module_default()).cardsGrid,
                        children: universitydata?.length > 0 && universitydata.map((universitydetails, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (DelegatesSection_module_default()).cardWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (DelegatesSection_module_default()).universityCard,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (DelegatesSection_module_default()).cardImageWrapper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: universitydetails?.cardImage?.imageUrl || "/images/admissionsday/universitya.png",
                                                width: 260,
                                                height: 220,
                                                className: (DelegatesSection_module_default()).cardImage,
                                                alt: "University-Representative.png"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (DelegatesSection_module_default()).cardBody,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (DelegatesSection_module_default()).universityName,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        children: universitydetails?.cardUniversityName?.label
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (DelegatesSection_module_default()).universitySubtitle,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        children: universitydetails?.cardUniversityName?.value
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var DelegatesSection_DelegatesSection = (DelegatesSection);

;// CONCATENATED MODULE: ./components/AdmissionsDay/AdmissionsDayLanding.tsx





















const AdmissionsDayLanding = (props)=>{
    const router = (0,next_router.useRouter)();
    const eventData = props.pageData[0];
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--event-bgcolor", eventData?.bannerSection?.sectionBgColor || "#6C48F0");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...eventData.meta
            }),
            eventData?.bannerSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdmissionDayheadr/* default */.Z, {
                    data: eventData?.bannerSection,
                    jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                    externalLink: eventData?.externalLink
                })
            }),
            router.asPath.includes("/company/") ? eventData?.whyStudySection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyStudyinCountry/* default */.Z, {
                    whystudydata: eventData?.whyStudySection,
                    jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                    externalLink: eventData?.externalLink
                })
            }) : eventData?.benefitsSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitsOfAdmissionsDay/* default */.Z, {
                    benefitdata: eventData?.benefitsSection
                })
            }),
            eventData?.participatingSection?.length > 0 && (router.asPath.includes("/admissions-day/") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DelegatesSection_DelegatesSection, {
                    universitydata: eventData?.participatingSection,
                    univertitle: eventData?.participatingSectionTitle,
                    universitybackcolor: eventData?.participatingSectionBgColor
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParticipatingUniversities_ParticipatingUniversities, {
                    universitydata: eventData?.participatingSection,
                    univertitle: eventData?.participatingSectionTitle,
                    universitybackcolor: eventData?.participatingSectionBgColor
                })
            })),
            eventData?.aboutSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdmissionsDay_AboutQut, {
                    aboutdata: eventData?.aboutSection
                })
            }),
            eventData?.whyChooseSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdmissionsDay_WhyChoose, {
                    whyChoosedata: eventData?.whyChooseSection,
                    jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                    externalLink: eventData?.externalLink
                })
            }),
            eventData?.participationCoursesSectionNew && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularCourses/* default */.Z, {
                    coursedata: eventData?.participationCoursesSectionNew
                })
            }),
            eventData?.howToAttendSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HowToAttendEvent/* default */.Z, {
                    howToAttendEventData: eventData?.howToAttendSection
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GrabChanceSection/* default */.Z, {
                eventData: eventData
            }),
            router.asPath.includes("/company/") ? eventData?.benefitsSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitsOfAdmissionsDay/* default */.Z, {
                    benefitdata: eventData?.benefitsSection
                })
            }) : eventData?.whyStudySection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyStudyinCountry/* default */.Z, {
                    whystudydata: eventData?.whyStudySection,
                    jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                    externalLink: eventData?.externalLink
                })
            }),
            eventData?.whyChooseKc && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairWhyChoosekc["default"], {
                    data: eventData?.whyChooseKc
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccomplishSection/* default */.Z, {
                eventData: eventData
            }),
            eventData?.studentsSaySection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    background: eventData?.studentsSaySection?.sectionBgColor || "#EEF2FB"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairStudTestimonials["default"], {
                    data: eventData?.studentsSaySection
                })
            }),
            eventData?.kcNumbersSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairKcByNumber["default"], {
                    data: eventData?.kcNumbersSection
                })
            }),
            eventData?.faqSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StudiesFAQ["default"], {
                    faqdata: eventData?.faqSection
                })
            }),
            eventData?.footer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairFooter/* default */.Z, {
                    data: eventData?.footer,
                    jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                    externalLink: eventData?.externalLink
                })
            })
        ]
    });
};
/* harmony default export */ var AdmissionsDay_AdmissionsDayLanding = (AdmissionsDayLanding);


/***/ }),

/***/ 6375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83157);
/* harmony import */ var _styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__);










const PopularCourses = ({ coursedata  })=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const settings = {
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 3,
        slidesPerRow: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dotsClass: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().sliderDots),
                    dots: true
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().popularcourses),
            style: {
                backgroundColor: coursedata?.sectionBgColor || "#FFF1EF"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().heading),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    children: coursedata?.sectionTitle
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().popularCourseslider),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    ...settings,
                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().slider),
                                    ref: sliderRef,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            children: coursedata?.pointImage?.length > 0 && coursedata?.pointImage?.map((offer, ind)=>{
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                    xl: 6,
                                                    lg: 6,
                                                    md: 6,
                                                    sm: 12,
                                                    xs: 6,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().mainBox),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().box),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().img),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                                        src: offer.imageUrl || "/images/admissionsday/popularstart.png",
                                                                        width: 60,
                                                                        height: 60,
                                                                        className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studImg),
                                                                        alt: "handshake.png"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().para),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                        children: [
                                                                            " ",
                                                                            offer?.title
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }, ind);
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PopularCourses);


/***/ }),

/***/ 13684:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"DelegatesSection_hide-scrollbar__m4O9g","delegatesSection":"DelegatesSection_delegatesSection__eI41V","sectionHeading":"DelegatesSection_sectionHeading__fjbYM","sectionContainer":"DelegatesSection_sectionContainer__gu_fy","cardsGrid":"DelegatesSection_cardsGrid__57hQt","cardWrapper":"DelegatesSection_cardWrapper__l_vKt","universityCard":"DelegatesSection_universityCard__FdUp1","cardImageWrapper":"DelegatesSection_cardImageWrapper__jlzmM","cardImage":"DelegatesSection_cardImage__VSonZ","cardBody":"DelegatesSection_cardBody__j5wGg","universityName":"DelegatesSection_universityName__VXeVz","universitySubtitle":"DelegatesSection_universitySubtitle__1yREs","detailLabel":"DelegatesSection_detailLabel__tdbb2","detailValue":"DelegatesSection_detailValue__k1zka"};

/***/ }),

/***/ 6054:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"ParticipatingUniversities_hide-scrollbar__Xp6y2","universitiesSection":"ParticipatingUniversities_universitiesSection__pfjEX","registerButtonWrapper":"ParticipatingUniversities_registerButtonWrapper__YPShG","registerButton":"ParticipatingUniversities_registerButton__otwRq","sectionHeading":"ParticipatingUniversities_sectionHeading__OpaDz","sectionContainer":"ParticipatingUniversities_sectionContainer__j_mF4","cardsGrid":"ParticipatingUniversities_cardsGrid___49ef","cardWrapper":"ParticipatingUniversities_cardWrapper__waKuB","universityCard":"ParticipatingUniversities_universityCard__HOCHV","cardImageWrapper":"ParticipatingUniversities_cardImageWrapper__oIBGi","cardImage":"ParticipatingUniversities_cardImage__aw2qX","cardBody":"ParticipatingUniversities_cardBody__jODs8","universityName":"ParticipatingUniversities_universityName__Hig0H","universitySubtitle":"ParticipatingUniversities_universitySubtitle__xyIWc","detailsRow":"ParticipatingUniversities_detailsRow__YuYg_","detailLabel":"ParticipatingUniversities_detailLabel__9fNIh","detailValue":"ParticipatingUniversities_detailValue__OepPu"};

/***/ })

}]);